import React from 'react';

import './styles.scss';

import {updateObject} from '../../utils/reducerUtils';
import {authCallback} from '../../utils/bankIdLogin';

import sendPin from '../../api/sendPin';
import initCustomLogin from '../../api/initCustomLogin';

import queryString from 'query-string';

const parsedSearch = queryString.parse(window.top.location.search);
const key = parsedSearch.key;
const normalizePin = (pin) => {
	if (pin === undefined || pin === null) {
		return '';
	}

	return String(pin).replace(/\s+/g, '').toUpperCase();
};

class CustomLogin extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			inValidEmail: false,
			hasSendVerifcaiton: true,
			hasResendEmailwithPinCode: false,
			resendEmail: this.props.email,
			emailError: null,
			flowStatus: null,
			pswError: null,
			reqPin: normalizePin(this.props.pinCode),
			testUser: {
				firstName: null,
				lastName: null,
				email: this.props.email ? this.props.email : '',
				key: key ? key : null,
				pin: null,
				origin: 'childScreening',
			},
		};

		this.handleUpdate = this.handleUpdate.bind(this);
		this.handleUpdateTestUserEvent =
			this.handleUpdateTestUserEvent.bind(this);
		this.pinRef = React.createRef();
	}

	componentDidMount() {
		if (this.pinRef.current) this.pinRef.current.focus();
	}

	componentDidUpdate(prevProps) {
	if (prevProps.pinCode !== this.props.pinCode) {
		this.setState({
			reqPin: normalizePin(this.props.pinCode),
		});
	}

	if (prevProps.email !== this.props.email) {
		this.setState((prevState) => ({
			resendEmail: this.props.email,
			testUser: updateObject(prevState.testUser, {
				email: this.props.email ? this.props.email : '',
			}),
		}));
	}
}
	validateEmail() {
		const email = this.state.testUser.email;

		if (/^\S+@\S+$$/.test(email)) {
			this.setState({
				inValidEmail: false,
			});

			if (!this.state.hasSendVerifcaiton) {
				this.sendPinToUserEmailAddress(this.state.testUser);
			}
		} else {
			this.setState({
				inValidEmail: true,
			});
		}
	}

	handleUpdateTestUserEvent(event) {
		const target = event.target;
		const key = target.name;
		const raw = target.value || '';

		const value =
	key === 'pin'
		? normalizePin(raw)
		: raw;

		this.handleUpdate(key, value);
	}

	handleUpdate(key, value) {
		const {testUser} = this.state;

		this.setState({
			testUser: updateObject(testUser, {
				[key]: value,
			}),
		});
	}

	sendPinToUserEmailAddress(testUser) {
	sendPin(testUser)
		.then((res) => {
			this.setState(
				{
					hasResendEmailwithPinCode: true,
					hasSendVerifcaiton: true,
					reqPin: normalizePin(res.PIN),
					flowStatus: null,
				},
				() => {
					if (this.pinRef.current) this.pinRef.current.focus();
				}
			);
		})
		.catch(() => {
			this.setState({
				flowStatus: 'Fel testkod eller e-post',
			});
		});
}

	initCustomLogin() {
	const enteredPin = normalizePin(this.state.testUser.pin);
	const requiredPin = normalizePin(this.state.reqPin);

	if (!enteredPin) {
		this.setState({
			flowStatus: 'Fel pinkod',
		});
		return;
	}

	if (requiredPin && requiredPin !== enteredPin) {
		this.setState({
			flowStatus: 'Fel pinkod',
		});
		return;
	}

	initCustomLogin(
		updateObject(this.state.testUser, {
			pin: enteredPin,
		})
	)
		.then((results) => {
			results.top = true;

			if (
				results &&
				results.action === 'auth' &&
				results.result === 'OK'
			) {
				window.removeEventListener('message', authCallback);

				localStorage.setItem(
					'authtoken-screening',
					results.authToken
				);

				window.top.location.href = `/test`;
			} else {
				this.setState({
					flowStatus: 'Ogiltig testkod',
				});
			}
		})
		.catch(() => {
			this.setState({
				flowStatus: 'Ogiltig testkod',
			});
		});
}

	render() {
		return (
			<div className="lit-customLogin lit-card">
				{this.state.hasSendVerifcaiton && (
					<div className="lit-customLogin-wrapper">
						<div className="lit-customPin-form-wrapper">
							{this.state.flowStatus && (
								<div className="lit-invalid-status-container">
									<p
										className="lit-invalid-note"
										role="status"
										aria-live="polite"
									>
										{this.state.flowStatus}
									</p>
								</div>
							)}

							{this.props.email &&
								!this.state.hasResendEmailwithPinCode && (
									<div
										className="lit-pin-instrucitons"
										id="pin-instructions"
									>
										<p>
											<span>
												Ange <b>PINKOD</b> och starta
												testet. Om du inte har fått
												pinkoden från din lärare kan du
												få den skickad till den
												registrerade e-postadressen{' '}
												<span style={{color: 'Lime'}}>
													<b>
														<em>
															{this.props.email}
														</em>
													</b>
												</span>
											</span>
										</p>
									</div>
								)}

							{this.props.email &&
								this.state.hasResendEmailwithPinCode && (
									<div
										className="lit-pin-instrucitons"
										id="pin-instructions"
									>
										<p>
											<span>
												<span>
													Vi har skickat ett
													e-postmeddelande med
													pinkoden till{' '}
													<span
														style={{color: 'Lime'}}
													>
														<b>
															<em>
																{
																	this.props
																		.email
																}
															</em>
														</b>
													</span>
													.{' '}
												</span>
												Ange <b>PINKOD</b> och starta
												testet. Kontakta din lärare om
												du inte har fått pinkoden
												skickad till dig.
											</span>
										</p>
									</div>
								)}

							{!this.props.email && (
								<div
									className="lit-pin-instrucitons"
									id="pin-instructions"
								>
									<p>
										<span>
											Skriv din pinkod här. Om du inte
											känner till pinkoden, fråga din
											lärare om den.
										</span>
									</p>
								</div>
							)}

							<form
								className="register-form"
								onSubmit={(event) => {
									event.preventDefault();
									this.initCustomLogin();
								}}
							>
								<div className="lit-customPin-form-wrapper">
									<div className="lit-customPIn-inner-content">
										<div className="lit-compound-pin-fields">
											<div className="lit-label-pin">
												<label
													className="customLogin-pin-lbl"
													htmlFor="pin-kode"
												>
													PINKOD:{' '}
												</label>

												<input
													ref={this.pinRef}
													required
													name="pin"
													id="pin-kode"
													className="customLogin-pin-tf"
													placeholder="skriv här"
													aria-label="Pinkod, 4 tecken"
													aria-describedby="pin-instructions"
													autoComplete="one-time-code"
													inputMode="text"
													maxLength={4}
													onChange={
														this
															.handleUpdateTestUserEvent
													}
													type="text"
												/>
											</div>
										</div>
									</div>

									<div className="lit-pincode-inlogg">
  <div className="lit-btn-submit-wrapper">
    <button className="lit-btn-submit">
      {'Starta testet'}
    </button>
  </div>

  {this.props.email && (
    <div className="lit-btn-submit-wrapper">
      <button
	  type="button"
        className={
          this.state.testUser.pin
            ? 'lit-btn-submit-pin__disabled'
            : 'lit-btn-submit-pin'
        }
       disabled={!!this.state.testUser.pin}
        onClick={(event) => {
          event.preventDefault();
          this.sendPinToUserEmailAddress({
            email: this.props.email,
            key,
            origin: 'childScreening',
          });
        }}
      >
        {'Skicka pinkod'}
      </button>
    </div>
  )}
</div>
								</div>
							</form>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default CustomLogin;